import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Col, Row } from "antd";

import LeadContent from "../components/lead-search/LeadContent";
import { getExecutiveEmployeeList } from "../actionCreator/leadListingActionCreater";
import "../assets/css/dynemic-page.css";
import { AuthContext } from "../context/AuthContext";

const LeadSearch = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { collapsed } = useContext(AuthContext);

  const selectedRecords = useSelector(
    (state) => state.leadListingReducer.selectedRecords,
  );
  const companyFilterList = useSelector((state) => state.leadListingReducer);
  const currentPage = parseInt(searchParams.get("page")) || 1;
  const itemsPerPage = parseInt(searchParams.get("size")) || 10;
  const totalItems = companyFilterList?.totalExecutiveCount;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  useEffect(() => {
    const getClientLeads = () => {
      const allParams = {};
      for (const [key, value] of searchParams.entries()) {
        allParams[key] = value;
      }

      dispatch(
        getExecutiveEmployeeList({
          ...allParams,
          page: allParams?.page ? allParams?.page - 1 : 0,
        }),
      );
    };
    getClientLeads();
  }, [dispatch, searchParams]);

  return (
    <div
      id="tabscompany"
      className={
        collapsed
          ? "tabs-extra-content-collapsed tw-px-4 tw-py-4 tw-h-[calc(100vh-64px)] tw-overflow-hidden"
          : "tabs-extra-content tw-px-4 tw-py-4 tw-h-[calc(100vh-64px)] tw-overflow-hidden"
      }
    >

      <Row className="tw-items-center tw-mb-2 tw-gap-y-2">
        <Col xs={24} md={10} lg={12}>
          <h2 className="tw-text-2xl tw-font-bold tw-text-slate-800 tw-m-0">
            Search Leads
          </h2>
          <p className="tw-text-slate-500 tw-text-xs tw-mt-1 tw-mb-0">
            Search, filter and manage your lead contacts and CRM data.
          </p>
        </Col>
        <Col
          xs={24}
          md={14}
          lg={12}
          className="tw-flex tw-items-center md:tw-justify-end tw-gap-2 tw-flex-wrap"
        >
          {!!selectedRecords?.length && (
            <span className="tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-text-xs tw-font-semibold tw-py-1 tw-px-3 tw-rounded-full tw-shadow-sm">
              {selectedRecords?.length} records selected
            </span>
          )}
          {totalItems > 0 && (
            <span className="tw-bg-slate-100 tw-text-slate-600 tw-text-xs tw-font-medium tw-py-1 tw-px-3 tw-rounded-full">
              Showing {startItem} - {endItem} of{" "}
              {totalItems?.toLocaleString()} results
            </span>
          )}
        </Col>
      </Row>

      <LeadContent />
    </div>
  );
};

export default LeadSearch;
